import httpService from "./httpService";

export interface WebSupportProof {
  kind: "jwt";
  platform: "web";
  userId: string;
  proof: string;
  expiresAtUtc: string;
}

/** The one backend call also attempts eligible contact provisioning. Never persist this response. */
export async function getWebSupportProof(actorId: string, signal: AbortSignal): Promise<WebSupportProof> {
  const controller = new AbortController();
  const abort = () => controller.abort();
  signal.addEventListener("abort", abort, { once: true });
  if (signal.aborted) abort();
  // Covers response-body consumption too; contact provisioning alone can take 30 seconds.
  const timeout = setTimeout(abort, 45_000);
  try {
    const response = await httpService.post<unknown>(
      "/v3/accounts/support/identity-proof",
      { platform: "web" },
      { requestScope: "actor", retryOnUnauthorized: false, cache: "no-store", timeout: 45_000, signal: controller.signal }
    );
    const proof = response.data;
    if (controller.signal.aborted || !proof || typeof proof !== "object"
      || !("kind" in proof) || proof.kind !== "jwt"
      || !("platform" in proof) || proof.platform !== "web"
      || !("userId" in proof) || proof.userId !== actorId
      || !("proof" in proof) || typeof proof.proof !== "string" || !proof.proof.trim()
      || !("expiresAtUtc" in proof) || typeof proof.expiresAtUtc !== "string"
      || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,3})?Z$/.test(proof.expiresAtUtc)
      || !Number.isFinite(Date.parse(proof.expiresAtUtc)) || Date.parse(proof.expiresAtUtc) <= Date.now()) {
      throw new Error("Support identity unavailable");
    }
    return proof as WebSupportProof;
  } finally {
    clearTimeout(timeout);
    signal.removeEventListener("abort", abort);
  }
}
